import React from 'react'
import { connect } from 'react-redux'

// Bootstrap — imported as a standalone CSS file so webpack processes it through
// the node_modules CSS pipeline and the PostCSS plugin in craco.config.js
// wraps it in @layer bootstrap automatically.
import 'bootstrap-css-only/css/bootstrap.min.css'

// global styles — all wrapped in @layer legacy
import './assets/kit-vendors/antd/style.scss'
import './assets/kit-vendors/nprogress/layer-wrapper.scss'
import './assets/kit-vendors/chartist/layer-wrapper.scss'
import './assets/kit-vendors/chartist-tooltip-plugin/layer-wrapper.scss'
import './assets/cometchat/style.scss'

// antd themes

// import AntDesignDarkTheme from './assets/kit-vendors/antd/themes/themeDark'
import AntDesignLightTheme from './assets/kit-vendors/antd/themes/themeLight'

const mapStateToProps = ({ settings: { theme } }) => ({ theme })

@connect(mapStateToProps)
class StyleLoader extends React.Component {
  setCurrentTheme = theme => {
    switch (theme) {
      //   case 'dark':
      //     window.less.modifyVars(AntDesignDarkTheme)
      //     this.switchActiveBodyClassnameTo('theme-dark')
      //     break
      default:
        window.less?.modifyVars?.(AntDesignLightTheme)
      // this.switchActiveBodyClassnameTo('theme-light')
    }
  }

  // switchActiveBodyClassnameTo = active => {
  //   const classesToRemove = ['theme-dark', 'theme-light']
  //   classesToRemove.forEach(name => document.body.classList.remove(name))
  //   document.body.classList.add(active)
  // }

  render() {
    // const { theme } = this.props
    const theme = 'light'
    this.setCurrentTheme(theme)
    return null
  }
}

export default StyleLoader
